import type { ReactNode } from 'react';
import type { DefaultTheme } from 'styled-components';

import { ThemeProvider } from 'styled-components';

import { useTextDirection } from '../../hooks/useTextDirection';

import { theme as defaultTheme } from './theme';

type DotThemeProviderProps = {
  children: ReactNode;
  theme?: DefaultTheme;
};

export const DotThemeProvider = ({ children, theme = defaultTheme }: DotThemeProviderProps) => {
  const textDirection = useTextDirection();

  const appTheme: DefaultTheme = JSON.parse(JSON.stringify(theme));

  appTheme.isRtl = textDirection === 'rtl';

  return <ThemeProvider theme={appTheme}>{children}</ThemeProvider>;
};
